import SideMenuRouter from 'mrf/view/SideMenuRouter';
import CommunicationLicensesReport from 'components/reports/CommunicationLicensesReport';
import CommunicationProcessesReport from 'components/reports/CommunicationProcessesReport';
import CommunicationAssignmentsReport from 'components/reports/CommunicationAssignmentsReport';
import { useTranslation } from 'react-i18next';

export default function Reports ({ match }){
    
    const {t} = useTranslation();

    const menuList = [
        {
            title: t('Processes'),
            path: '/communicationProcesses',
            component: CommunicationProcessesReport,
        },
        {
            title: t('Licenses'),
            path: '/communicationLicenses',
            component: CommunicationLicensesReport,
        },
        {
            title: t('Assignments'),
            path: '/communicationAssignments',
            component: CommunicationAssignmentsReport,
        },
    ];

    return (
        <SideMenuRouter 
            match={match} 
            menuList={menuList} 
            indexComponent={CommunicationProcessesReport} 
        />
    );
}
